// removed by extract-text-webpack-plugin
module.exports = {"grid-figure":"Rz4Y3P4Dyiy2k2O29awBY","card-title":"_1tuzl9mFDfiobUBm9YOxwu","center":"_1Q2JizY5ZqQfmaK5mjeTrH","no-answer":"_1mwzPPcskyxzV-6RpWRDhK","card-contents":"_1MlyG8dDqDQ1hqHQYj7Mcz"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Card.styl
// module id = 572
// module chunks = 0